/**
 * Resolve the price a customer actually pays on a product.
 *
 * Priority (mirrors backend _resolve_customer_price):
 *   1. Per-product manual override (admin-set) — wins flat
 *   2. Tier discount applied to catalog price
 *   3. Catalog price unchanged
 *
 *   priceForCustomer({ retail: 0.300, discountPct: 10 })            → 0.270
 *   priceForCustomer({ retail: 0.300, discountPct: 10, override: 0.180 }) → 0.180
 *   priceForCustomer({ retail: 0.300 })                              → 0.300
 */
export const priceForCustomer = ({ retail, discountPct, override }) => {
  const r = Number(retail) || 0;
  if (override !== undefined && override !== null && override !== '') {
    const o = Number(override);
    if (Number.isFinite(o) && o >= 0) {
      return Number(o.toFixed(3));
    }
  }
  const d = Number(discountPct) || 0;
  if (d <= 0) return r;
  return Number((r * (1 - d / 100)).toFixed(3));
};

/**
 * Backwards-compatible wrapper kept for the existing call sites.
 * New code should prefer priceForCustomer().
 */
export const priceWithTier = (retail, discountPct, override) =>
  priceForCustomer({ retail, discountPct, override });
